import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageMeta } from '../../utils/pageMeta';
import { getVisibleOblastiBySkupOblastiId, getSkupOblastiById } from '../../server/server-kategorije-tree';
import { useUser } from '../../auth/UseUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { Oval } from 'react-loader-spinner';
import { ObrazovanjeItem } from './ObrazovanjeHome';

function SkupOblastiObrazovanjeHome() {
    const { id } = useParams<any>();
    const navigate = useNavigate();
    const { navLista, setNavLista, returnedList, setReturnedList, setTipEtiteta } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const [skupOblasti, setSkupOblasti] = useState<any>(null);
    usePageMeta(skupOblasti?.naziv, skupOblasti?.opis);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!!id) loadSkupOblasti();
    }, [id]);

    const loadSkupOblasti = async () => {
        setLoading(true);
        const resp = await getSkupOblastiById(id);
        if (resp.status == 200) {
            const item = resp.data;
            setSkupOblasti(item);
            let newList: any[] = [];
            if (item.podkategorija?.kategorija) newList.push(item.podkategorija.kategorija);
            if (item.podkategorija) newList.push(item.podkategorija);
            newList.push(item);
            setNavLista(newList);
            setTipEtiteta(TypeOfEtity.Oblast);
            setReturnedList(resp.data.oblasti);
            setMainList(resp.data.oblasti);
            setLoading(false);
            //loadOblasti(id);
        } else {
            setLoading(false);
        }
    };

    const loadOblasti = async (id: string | undefined) => {
        const resp = await getVisibleOblastiBySkupOblastiId(id);
        if (resp.status === 200) {
        }
    };

    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark no-scroll">
            <div className=" obrazovanje-outer-frame-mobile lg:obrazovanje-outer-frame-web">
                <div className=" obrazovanje-inner-frame-mobile sm:obrazovanje-inner-frame-web">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                {skupOblasti?.naziv}: <span className="text-white">{skupOblasti?.opis}</span>
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {mainList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SkupOblastiObrazovanjeHome;
